import CONFIG from './config';
import { AppBrands, DefaultUrlValues, DefaultUrlValuesBrekr } from './constants';

export const getDefaultUrlValues = () => {
    const isBrekr = CONFIG.APP_BRAND === AppBrands.BREKR;

    return isBrekr ? DefaultUrlValuesBrekr : DefaultUrlValues;
};
